import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeselectedCatService } from "../../store/slice/orderSlice";
import { ReactComponent as InlineIcon } from "../../inlineSvgs/horizontal.svg";
import { ReactComponent as LayoutIcon } from "../../inlineSvgs/layout.svg";

const CatServicesList = () => {
  const [displayType, setDisplayType] = useState(true);
  const curentStudio = useSelector((state) => state.orderReducer.selectedStudio);

  const studioServices = curentStudio?.services.reduce((cats, service) => [...cats, ...service.categories], []);
  const table = {};
  const studioCategories = studioServices?.filter(({ id }) => !table[id] && (table[id] = 1));

  return (
    <div className="services-list">
      <div className="services-list__head">
        <div className="title">Select Services Category</div>
        <div className="description">
          Explore beauty services, select those that suit your preferences, and personalize your self-care.
        </div>
        <button onClick={() => setDisplayType(!displayType)} className="change-view-btn">
          {displayType ? <InlineIcon /> : <LayoutIcon />}
        </button>
      </div>
      {studioCategories ? (
        <div className={displayType ? "services" : "services inline"}>
          {studioCategories?.map((cat) => (
            <Service key={cat.id} {...cat} />
          ))}
        </div>
      ) : (
        <p className="title">Please select a studio</p>
      )}
    </div>
  );
};

const Service = (service) => {
  const { title } = service;
  const curentService = useSelector((state) => state.orderReducer.selectedCatService);
  const isActive = curentService && curentService?.id === service?.id;
  const dispatch = useDispatch();

  const chooseService = () => {
    dispatch(changeselectedCatService(service));
  };

  return (
    <div className={isActive ? "service curent" : "service"} onClick={chooseService}>
      <img src="./img/test.png" alt="Category img" />
      <p>{title}</p>
    </div>
  );
};

export default CatServicesList;
